import { render, staticRenderFns } from "./CallPhone.vue?vue&type=template&id=8094b55e"
import script from "./CallPhone.vue?vue&type=script&lang=js"
export * from "./CallPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports